export default {
  created(el, binding, vnode, prevVnode) {

    function addZeroes(num) {
      const dec = num.split('.')[1]
      const len = dec && dec.length > 2 ? dec.length : 2
      return Number(num).toFixed(len)
    }

    document.addEventListener('mousemove', (event) => {
      let x = (event.clientX * 100) / window.innerWidth;
      let y = (event.clientY * 100) / window.innerHeight;

      if (binding.arg == 'y') {
        el.innerHTML = parseFloat(addZeroes(y.toFixed(4)));
      } else {
        el.innerHTML = parseFloat(addZeroes(x.toFixed(4)));
      }
    });
  },
}